import { formatDuration } from '@vgtv/time-helpers';
import { FunctionComponent } from 'preact';
import { useCallback, useState } from 'preact/hooks';

import { usePlayer } from '../../hooks/PlayerProvider';
import { useJWPlayerEvent } from '../../hooks/useJWPlayerEvent';
import { Typography, TypographyProps } from '../Typography/Typography';

const formatProgress = (position: number, duration: number) => {
  return `${formatDuration(position * 1000)} / ${formatDuration(
    duration * 1000
  )}`;
};

export const VodTimeDisplay: FunctionComponent<{
  color?: TypographyProps['color'];
}> = ({ color = 'white' }) => {
  const player = usePlayer();

  const [progress, setProgress] = useState({
    position: player.getCurrentTime(),
    duration: player.getDuration(),
  });

  const handleTime = useCallback((param: jwplayer.TimeParam) => {
    setProgress({
      position: param.position,
      duration: param.duration,
    });
  }, []);

  useJWPlayerEvent('time', handleTime);

  return (
    <div className="vgp-time-display">
      <Typography color={color} variant="label" size="medium" bold>
        {formatProgress(progress.position, progress.duration)}
      </Typography>
    </div>
  );
};
